import BaseService from '../BaseService'
import axios from "axios";

class ProductService extends BaseService {
    constructor() {
        super('/products');
    }

    latestReviews() {
        return axios.get(`${this.resource}/last-reviews`)
    }

    countsMonthly() {
        return axios.get(`${this.resource}/reviews-counts-monthly`)
    }

    trackingProducts({query = ''}) {
        const q = query.length > 0 ? `?${query}` : ''

        return axios.get(`${this.resource}/tracking-products${q}`)
    }

    untrackProduct ({ payload }) {
        return axios.post(`${this.resource}/untrack-product`, payload)
    }

    getReviewHighlights ({ id, query = '' }) {
        const q = query.length > 0 ? `?${query}` : ''

        return axios.get(`${this.resource}/review-highlights/${id}${q}`)
    }
}

export default new ProductService()
